export default __webpack_public_path__ + "static/media/36I-114291_-21028_0.27064df1.jpg";